import { anonymousRoutes, constantRoutes, errRoutes } from "@/router";
import { refreshRoutes } from "@/api/menus/menuTransfer";

const state = {
  routes: constantRoutes.concat(anonymousRoutes),
  partialRoutes: [],
};
const getters = {
  routes: (state) => state.routes,
  partialRoutes: (state) => state.partialRoutes,
};
const mutations = {
  setRoutes(state, routes) {
    state.routes = constantRoutes.concat(routes);
  },
  setAllRoutes(state, routes) {
    state.routes = constantRoutes.concat(routes);
  },
  setPartialRoutes(state, routes) {
    state.partialRoutes = constantRoutes.concat(routes);
  },
};
const actions = {
  async setRoutes({ commit }, role) {
    const asyncRoutes = (await refreshRoutes(role)).concat(errRoutes);
    commit("setRoutes", asyncRoutes);
    return asyncRoutes;
  },
  async setAllRoutes({ commit }) {
    const asyncRoutes = (await refreshRoutes()).concat(errRoutes);
    commit("setAllRoutes", asyncRoutes);
    return asyncRoutes;
  },
  setPartialRoutes({ commit }, accessRoutes) {
    commit("setPartialRoutes", accessRoutes);
    return accessRoutes;
  },
};
export default { state, getters, mutations, actions };
